import { Component } from 'preact';

export default class Red extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
                :root {
                    /* Global */
                    --brand-global-radius: 0;

                    /* Colors */
                    --brand-color-background: #FFF;
                    --brand-color-secondary: #FFF;
                    --brand-color-border: #D2D2D2;
                    --brand-color-body: #000000;
                    --brand-color-primary: #E61B24;
                    --brand-color-focus: #FFCC00;

                    /* Fonts */
                    --brand-font-family-title: "Arial", serif;
                    --brand-font-family-body: "Arial";
                    --brand-font-weight-regular: 400;
                    --brand-font-weight-bold: 700;

                    /* Title */
                    --brand-title-weight: 700;
                    --brand-title-transform: uppercase;
                    --brand-title-spacing: 0;

                    /* Input */
                    --brand-input-border-width: 1px;
                    --brand-input-border-color: #000;

                    /* Button */
                    --brand-button-radius: 0;
                    --brand-button-border-size: 0;
                    --brand-button-border-color: transparent;
                    --brand-button-font-color: #FFF;
                    --brand-button-font-size: 14px;
                    --brand-button-font-weight: 700;
                    --brand-button-font-transform: uppercase;
                    --brand-button-font-spacing: 1px;
                  }
            `
            }}></style>

        );
    }
}